export function charLimitedString(str: string = '', limit: number = 0): string {
    if (str.length <= limit) return str;

    const words = str.split(' ');
    let newString = '';

    for (let i = 0; i < words.length; i++) {
        const combinedString = newString === '' ? words[i] : `${newString} ${words[i]}`;

        if (combinedString.length <= limit) {
            newString = combinedString;
        } else {
            const numCharsOverLimit = combinedString.length - limit;
            const lastChar = combinedString[combinedString.length - 1];

            if (numCharsOverLimit === 1 && lastChar.match(/[^a-zA-Z0-9]/)) {
                newString = combinedString.slice(0, -1);
            }

            break;
        }
    }

    return newString;
}
